import React from 'react';
import { DashboardWidgetComponent } from '../../../interfaces/DashboardWidgetComponent';
import { ViewSaved } from '../../../../shared/entities/view/components/view/interfaces/api/ViewSaved';
import DashboardSavedViewsWidget from './DashboardSavedViewsWidget';
import { SavedViewsType } from '../../../../shared/entities/view/components/view/components/view-saved/enums/SavedViewsType';

const DashboardMyScreensWidget: DashboardWidgetComponent<ViewSaved[]> = props => {
  return <DashboardSavedViewsWidget type={SavedViewsType.Screens} savedViews={props.data} />;
};

export default DashboardMyScreensWidget;
